import { ItemEat } from '@components/ItemEat';
import LoadingContainer from '@components/LoadingContainer';
import T from '@components/Translate';
import { LISTING_CLASS } from '@containers/Eat/classNames';
import { getNextPage } from '@utils/pagination';
import { useRouter } from 'next/router';
import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectEat, selectIsLoading } from '../selectors';
import { GET_EAT } from '../slice';

interface Props {
  park: string;
}

const EatListing = memo(({ park }: Props) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const eat = useSelector(selectEat);
  const loading = useSelector(selectIsLoading);

  return (
    <div className={LISTING_CLASS.root}>
      <div className="container-fluid">
        <div className={LISTING_CLASS.top}>
          <div>
            <div className="titleFrame">
              <T tKey={`${park}.home-event`} />
            </div>
            <div className={LISTING_CLASS.total}>
              {eat?.paginator?.totalCount} Địa điểm
            </div>
          </div>
        </div>
        <LoadingContainer loading={loading}>
          {eat?.data?.length > 0 ? (
            <>
              <div className={LISTING_CLASS.list}>
                {eat?.data?.map((item, i) => <ItemEat key={i} item={item} />)}
              </div>
              {eat?.data?.length < eat?.paginator?.totalCount && (
                <div
                  className={LISTING_CLASS.viewMore}
                  onClick={() => {
                    dispatch(
                      GET_EAT({
                        SiteCode: park,
                        page: getNextPage(eat?.data?.length),
                        locale: router.locale,
                      }),
                    );
                  }}
                >
                  <T tKey="SunParadiseLand.viewMore" />
                </div>
              )}
            </>
          ) : (
            <div className="noData">
              <T tKey="SunParadiseLand.noData" />
            </div>
          )}
        </LoadingContainer>
      </div>
    </div>
  );
});

export default EatListing;
